/**
 * 对外项目展示名称（与 ICP 备案、后端 CommonConstants.PROJECT_DISPLAY_NAME 一致）。
 * npm 包名 membership-man、localStorage 键名等为内部技术标识，不在此修改。
 */
export const APP_NAME = '个人万象';

/** 登录页副标题 */
export const APP_TAGLINE = '个人内容与资料整理';

/** HTML meta description（对外展示，勿写技术栈/架构用语） */
export const APP_DESCRIPTION =
    '个人万象 — 个人非经营性网站，用于学习笔记与多媒体资料的整理展示。';

/**
 * ICP 备案信息（工信部要求：首页底部居中展示，并链至备案管理系统）
 * @see https://beian.miit.gov.cn/
 */
export const ICP_BEIAN_NUMBER = '鄂ICP备2026028600号-1';

/** 页脚 ICP 备案号前缀文案 */
export const ICP_BEIAN_LABEL = 'ICP备案号';

/** 工信部 ICP/IP 地址/域名信息备案管理系统首页 */
export const MIIT_BEIAN_HOME_URL = 'https://beian.miit.gov.cn/';

/**
 * 公安联网备案号（图标在左、编号在右，链至全国互联网安全管理服务平台）
 * @see https://beian.mps.gov.cn/
 */
export const GONGAN_BEIAN_NUMBER = '鄂公网安备 42110002000388号';

/** 公安备案图标（public 静态资源） */
export const GONGAN_BEIAN_ICON = `${process.env.PUBLIC_URL || ''}/beian-gongan.png`;

/** 公安备案查询链接 */
export const BEIAN_LINK_URL =
    'https://beian.mps.gov.cn/#/query/webSearch?code=42110002000388';
